import React from 'react'
import { useTranslation } from 'react-i18next'

interface Props {
  fields: string[]
}

// Explicit table rather than a key built at runtime: i18n typing checks it
const fieldKeys = {
  name: 'LogFieldsList.name',
  purpose: 'LogFieldsList.purpose',
  domain: 'LogFieldsList.domain',
  accountabilities: 'LogFieldsList.accountabilities',
  checklist: 'LogFieldsList.checklist',
  indicators: 'LogFieldsList.indicators',
  notes: 'LogFieldsList.notes',
  singleMember: 'LogFieldsList.singleMember',
  autoCreate: 'LogFieldsList.autoCreate',
  base: 'LogFieldsList.base',
  parentLink: 'LogFieldsList.parentLink',
  colorHue: 'LogFieldsList.colorHue',
  avgMinPerWeek: 'LogFieldsList.avgMinPerWeek',
  archived: 'LogFieldsList.archived',
  archivedAt: 'LogFieldsList.archivedAt',
} as const

// « la raison d'être et les redevabilités »: the changed fields, as a phrase
export default function LogFieldsList({ fields }: Props) {
  const { t, i18n } = useTranslation()
  const labels = fields.map((field) => {
    const key = fieldKeys[field as keyof typeof fieldKeys]
    return key ? t(key) : field
  })
  return (
    <>
      {new Intl.ListFormat(i18n.language, {
        style: 'long',
        type: 'conjunction',
      }).format(labels)}
    </>
  )
}
